import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
import { updateQueryStringParameter } from '../helpers/index';
import { each, cloneDeep, map } from 'lodash';
import { appBasePath } from '../constants/staticData';
import moment from 'moment';

export function getAutosuggestedList() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_AUTO_SUGGESTED_LIST)
      .then((response) => {
        if (response.data) {
          dispatch({
            type: types.GET_AUTO_SUGGESTED_LIST,
            autoSuggestedList: response.data
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          if (err.response) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function openJobs(time) {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_OPEN_JOBS + '/' + time)
      .then((response) => {
        if (response.data) {
          console.log("response.data", response.data);
          dispatch({
            type: types.GET_OPEN_JOBS_DATA,
            getOpenJobsData: response.data,
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          if (err.response) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function increaseOpenJobs(type, data) {
  return (dispatch) => {
    dispatch({
      type: types.INCREASE_OPEN_JOBS,
      jobType: type,
      data: data
    });
  };
}


export function searchJobs(searchObject) {
  return (dispatch) => {
    if (searchObject) {
      axios.post(API_END_POINTS.SEARCH_JOBS, searchObject)
        .then((response) => {
          if (response.status === 200) {
            // let newUrl = '';
            // if (type == 'autosuggest') {
            let newUrl = 'results?id=' + searchObject.id + '&type=' + searchObject.type + '&desc=' + searchObject.description;
            // } else {
            //   newUrl = '/search-result?q=' + searchData;
            // }

            if (window.location.pathname == appBasePath + '/results') {
              let href = window.location.href;
              let updatedUrl = updateQueryStringParameter(href, 'id', searchObject.id);
              updatedUrl = updateQueryStringParameter(updatedUrl, 'type', searchObject.type);
              updatedUrl = updateQueryStringParameter(updatedUrl, 'desc', searchObject.description);
              window.history.replaceState(null, null, updatedUrl);
            }
            dispatch({
              type: types.SEARCH_VENDORS,
              vendorsListFromSearch: response.data,
              changeCurrentComponentKey: window.location.pathname == appBasePath + '/results' ? false : true,
              newUrl: newUrl
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: "Unknown error occurred please try again"
            });
          }
        })
        .catch((err) => {
          if (err.config) {
            if (err.response && err.response.status) {
              dispatch({
                type: types.SHOW_ERROR_MESSAGE,
                statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Unknown error occurred please try again'
              });
            } else {
              dispatch({
                type: types.SHOW_ERROR_MESSAGE,
                statusMessage: 'Unknown error occurred please try again'
              });
            }
          }
        });
    }
    else {
      dispatch({
        type: types.SEARCH_VENDORS,
        vendorsListFromSearch: [],
        changeCurrentComponentKey: window.location.pathname == appBasePath + '/results' ? false : true,
        newUrl: 'results'
      });
    }
  };
}

export function clearCommonReducerComponentKey() {
  return (dispatch) => {
    dispatch({
      type: types.CLEAR_COMPONENT_KEY
    });
  };
}


export function getNotificationAlerts(limit, offset, isLoadMore) {
  // const notificationsEndPoint = `${API_END_POINTS.GET_NOTIFICATION_ALERTS}/?page=${pageNumber || 1}&pagesize=${pageSize || 10}`;
  const notificationsEndPoint = `${API_END_POINTS.GET_NOTIFICATION_ALERTS}/?limit=${limit}&offset=${offset}`;
  return (dispatch) => {
    axios.get(notificationsEndPoint)
      .then((response) => {
        if (response.status == 200 && response.data) {
          const currentTimeStamp = moment(new Date());
          const nextDayTimeStamp = moment(new Date()).subtract(1, 'days');
          const notifications = map(response.data.data, (notification) => {
            const createdTimeStamp = moment(notification.created_at);
            notification.createdDate = createdTimeStamp.format('DD-MMM-YYYY');
            notification.createdTime = createdTimeStamp.format('HH:MM:A');
            notification.category = (createdTimeStamp.date() == currentTimeStamp.date()) ? 'today' : (moment(createdTimeStamp).isSame(nextDayTimeStamp, 'date')) ? 'yesterday' : 'old';
            return notification;
          });
          dispatch(getEmergencyList());
          dispatch({
            type: types.GET_NOTIFICATION_ALERTS,
            totalUnreadAlerts: response.data.totalUnreadAlerts,
            notifications: notifications || [],
            notificationsPageInfo: response.data.pageInfo || {},
            isLoadMore: isLoadMore || false
          });
        } else {
          dispatch({
            type: types.GET_NOTIFICATION_ALERTS,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_NOTIFICATION_ALERTS,
            unableToFetch: true
          });
        }
      });
  };
}

export function markNotificationAsRead(alertID) {
  return (dispatch) => {
    axios.put(API_END_POINTS.MARK_NOTIFICATION_AS_READ + alertID)
      .then((response) => {
        if ((response.status == 200) && response.data) {
          dispatch({
            type: types.MARK_NOTIFICATION_AS_READ,
            alertID: alertID
          });
        }
      });
  };
}

export function newSocketNotification(notification, notificationType) {
  notification.requestId = notification.requestId || notification.request_id;
  console.log("notification, notificationType = ", notification, notificationType);
  return (dispatch) => {
    if (notification.requestId) {
      axios.get(`${API_END_POINTS.GET_POSTED_JOB}/${notification.requestId}` + '?imageflow=1')
        .then((response) => {
          if (response.status == 200 && response.data) {
            const jobType = (response.data.garagejobquote && response.data.garagejobquote.jobdetailstatus && response.data.garagejobquote.jobdetailstatus.name) ? response.data.garagejobquote.jobdetailstatus.name.toLowerCase() : '';
            const isAppliedJob = ((notificationType == 'New Request' || notificationType == 'Auto Quote') && jobType == 'applied');
            if (notification.msg && isAppliedJob) {
              notification.msg = `Auto quote was triggered for Booking Request ${response.data.requestid}`;
            }
            if (notificationType === 'Request Cancel' || notificationType === 'Confirmed Job Decline' ) {
              dispatch({
                type: types.UPDATE_NEW_COUNT
              })
            }
            dispatch({
              type: types.CHANGE_STATUS_OF_SIDEBAR_COUNT,
              notificationType: isAppliedJob ? 'Applied Job' : notificationType,
              fromNotification: true,
              notification: notification
            });
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: notification.msg,
              toastType: 'success'
            });
            dispatch({
              type: types.UPDATE_OVERVIEW_GRAPHS,
              notificationType: notificationType
            });
            dispatch({
              type: types.NOTIFICATION_FROM_SOCKET,
              notification: notification,
              notificationType: notificationType
            });
            dispatch({
              type: types.GET_POSTED_JOB_BY_ID,
              jobDetails: response.data,
              jobStatus: response.data.requeststatus.displayname,
              replaceWaitingWithApplied: false,
              fromNotification: true,
              notificationType: isAppliedJob ? 'Applied Job' : notificationType,
              notification: notification
            });
            if (notificationType == 'Job For The Day') {
              dispatch({
                type: types.UPDATE_JOB_FOR_THE_DAY,
                jobCount: notification.jobCount,
                notificationType: notificationType
              });
            }
            if (notificationType == 'New Request' || notificationType == 'Job Loss' || notificationType == 'Job Accepted') {
              if (notificationType == 'Job Loss' || notificationType == 'Job Accepted') {
                dispatch({
                  type: types.UPDATE_OVERVIEW_WINLOSS,
                  incomingJob: notification,
                  jobType: isAppliedJob ? 'applied' : 'waiting'
                });
              }
              if (!isAppliedJob) {
                dispatch({
                  type: types.INCREASE_OPEN_JOBS,
                  jobType: 'newrequest',
                  data: notification
                });
              }
            }
          }
        });
    } else {
      dispatch({
        type: types.SHOW_TOAST_MESSAGE,
        toastMessage: notification.msg,
        toastType: 'success'
      });
    }
  };
}

export function showToastMessage(toastMessage, toastType) {
  return (dispatch) => {
    dispatch({
      type: types.SHOW_TOAST_MESSAGE,
      toastMessage: toastMessage,
      toastType: toastType
    });
  };
}

export function hideToastMessage() {
  return (dispatch) => {
    dispatch({
      type: types.HIDE_TOAST_MESSAGE,
    });
  };
}

export function getTopLocations() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_TOP_LOCATIONS)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_TOP_LOCATIONS,
            topLocations: response.data
          });
        } else {
          dispatch({
            type: types.GET_TOP_LOCATIONS,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_TOP_LOCATIONS,
            unableToFetch: true
          });
        }
      });
  };
}

export function getTopServices() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_TOP_SERVICES)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_TOP_SERVICES,
            topServices: response.data
          });
        } else {
          dispatch({
            type: types.GET_TOP_SERVICES,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_TOP_SERVICES,
            unableToFetch: true
          });
        }
      });
  };
}

export function getJobForToday() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_JOB_FOR_TODAY)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_JOB_FOR_TODAY,
            jobForToday: response.data.jobcount
          });
        } else {
          dispatch({
            type: types.GET_JOB_FOR_TODAY,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_JOB_FOR_TODAY,
            unableToFetch: true
          });
        }
      });
  };
}

export function getJobDistributionChart() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_JOB_DISTRIBUTION_CHART)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_JOB_DISTRIBUTION_CHART,
            jobDistributionChart: response.data
          });
        } else {
          dispatch({
            type: types.GET_JOB_DISTRIBUTION_CHART,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_JOB_DISTRIBUTION_CHART,
            unableToFetch: true
          });
        }
      });
  };
}

export function getBusinessTax() {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    axios
      .get(API_END_POINTS.BUSINESS_TAX+"?garage_id="+garage_id, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.GET_VENDOR_TAX,
            taxInfo: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function getJobCount() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_JOB_COUNT)
      .then((response) => {
        if (response.status == 200 && response.data) {
          let waitingTotalJobCount = 0;
          let waitingNewJobCount = 0;
          let appliedJobCount = 0;
          let confirmedJobCount = 0;
          let inProgressJobCount = 0;
          let completedJobCount = 0;
          each(response.data.waitingRequests, (job) => {
            if (job.isNewJob) {
              waitingNewJobCount += Number(job.requestCount);
              waitingTotalJobCount += Number(job.requestCount);
            } else {
              waitingTotalJobCount += Number(job.requestCount);
            }
          });
          each(response.data.otherJobs, (job) => {
            if (job.jobdetailstatusId == 1) {
              appliedJobCount += Number(job.jobcount);
            } else if (job.jobdetailstatusId == 3) {
              inProgressJobCount += Number(job.jobcount);
            } else if (job.jobdetailstatusId == 4) {
              confirmedJobCount += Number(job.jobcount);
            } else if (job.jobdetailstatusId == 7) {
              completedJobCount += Number(job.jobcount);
            }
          });
          dispatch({
            type: types.GET_JOB_COUNT,
            jobCount: {
              waiting: waitingTotalJobCount,
              waitingNewJob: waitingNewJobCount,
              applied: appliedJobCount,
              confirmed: confirmedJobCount,
              completed: completedJobCount,
              inprogress: inProgressJobCount
            },
            autoacceptjob: response.data.autoacceptjob
          });
        } else {
          dispatch({
            type: types.GET_JOB_COUNT,
            unableToFetch: true
          });
        }
      })
      .catch(() => {
        dispatch({
          type: types.GET_JOB_COUNT,
          unableToFetch: true
        });
      });
  };
}


export function confirmPayment(quoteData) {
  console.log('Going to create a quote --->', quoteData);
  return (dispatch) => {
    axios.post(`${API_END_POINTS.CONFIRM_PAYMENT}`, quoteData)
      .then((response) => {
        if (response.status === 200) {


          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Payment Status Successfully Update',
            toastType: 'success',
          });


        } else {


          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Unknown error occurred please try again',
            toastType: 'error'
          })
        }
        dispatch({
          type: types.CONFIRM_PAYMENT,
        })

      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.CONFIRM_PAYMENT,
            unableToMakePayment: true
          })
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response.data && err.response.data.err ? err.response.data.err : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}
export function getOverview() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_OVERVIEW)
      .then((response) => {
        if (response.status == 200 && response.data && response.data.data) {
          dispatch({
            type: types.GET_OVERVIEW,
            overviewData: response.data.data
          });
        } else {
          dispatch({
            type: types.GET_OVERVIEW,
            unableToFetch: true
          });
        }
      }).catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_OVERVIEW,
            unableToFetch: true
          });
        }
      });
  };
}

export function onboardingDone() {
  return dispatch => {
    axios
      .post(API_END_POINTS.CHANGE_BOARDING_STATUS, JSON.stringify({ onboardingDone: true }), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.CHANGE_BOARDING_STATUS,
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err.response && err.response.status === 404) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: "User account doesn't exists!"
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function createChatRoom(payLoad, vendorProfilePhoto) {
  return (dispatch) => {
    axios.post(API_END_POINTS.CREATE_CHAT_ROOM, payLoad)
      .then((response) => {
        if (response.data && response.status == 200) {
          const GET_ALL_MESSAGE_OF_CHAT_ROOM = API_END_POINTS.GET_ALL_MESSAGE_OF_CHAT_ROOM.replace('${roomId}', response.data.jobChatRoomId);
          const jobChatRoomId = response.data.jobChatRoomId;
          axios.get(GET_ALL_MESSAGE_OF_CHAT_ROOM)
            .then((response) => {
              if (response.status == 200) {
                dispatch({
                  type: types.CREATE_CHAT_ROOM,
                  jobChatRoomId: jobChatRoomId,
                  jobrequestId: payLoad.jobrequest_id,
                  messages: (response.data.messages && response.data.messages.length) ? response.data.messages.reverse() : response.data.messages,
                  customerId: payLoad.customer_id,
                  vendorProfilePhoto: vendorProfilePhoto
                });
              }
            });
        }
      });
  };
}

export function joinChatRoom(jobChatRoomId) {
  return (dispatch) => {
    dispatch({
      type: types.JOIN_CHAT_ROOM,
      currentJobChatRoomId: jobChatRoomId
    });
  };
}

export function sendNewMessage(message, jobrequestId, customerId, jobChatRoomId, vendorProfilePhoto) {
  return (dispatch) => {
    dispatch({
      type: types.SENT_NEW_MESSAGE,
      message: message,
      jobrequestId: jobrequestId,
      customerId: customerId,
      jobChatRoomId: jobChatRoomId,
      vendorProfilePhoto: vendorProfilePhoto
    });
  };
}
export function receiveNewMessage(messageData, jobChatRoomId) {
  return (dispatch) => {
    dispatch({
      type: types.RECEIVE_NEW_MESSAGE,
      message: messageData.msg,
      user: messageData.user,
      userbookingrequest: messageData.userbookingrequest,
      jobChatRoomId: jobChatRoomId
    });
    dispatch({
      type: types.UPDATE_OVERVIEW_GRAPHS,
      notificationType: 'job-message'
    });
  };
}

export function getAllChatRooms(garageId) {
  return (dispatch) => {
    axios.get(`${API_END_POINTS.GET_ALL_CHATROOMS}?garage=${garageId}`)
      .then((response) => {
        if (response.data && response.status == 200) {
          dispatch({
            type: types.GET_ALL_CHATROOMS,
            chatRooms: response.data.chatrooms
          });
        } else {
          dispatch({
            type: types.GET_ALL_CHATROOMS,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_ALL_CHATROOMS,
            unableToFetch: true
          });
        }
      });
  };
}

export function getAllUnreadMessages(garageId) {
  return (dispatch) => {
    axios.get(`${API_END_POINTS.GET_ALL_UNREAD_MESSAGES}?garage=${garageId}`)
      .then((response) => {
        if (response.status == 200 && response.data && response.data.messageAlerts) {
          dispatch({
            type: types.GET_ALL_UNREAD_MESSAGES,
            unreadMessages: response.data.messageAlerts.messages,
            unableToFetch: false
          });
        } else {
          dispatch({
            type: types.GET_ALL_UNREAD_MESSAGES,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_ALL_UNREAD_MESSAGES,
            unableToFetch: true
          });
        }
      });
  };
}
/*export function getEmergencyList(emergencyData) {
  return (dispatch) => {
    dispatch({
      type: types.EMERGENCY_LIST,
      emergencyList: emergencyData
    });
  };
}
*/
export function getEmergencyList() {
  //const notificationsEndPoint = limit ? `${API_END_POINTS.GET_NOTIFICATION_ALERTS}/?urgent=true` : API_END_POINTS.GET_NOTIFICATION_ALERTS;
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_NOTIFICATION_ALERTS + '/?urgent=true')
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.EMERGENCY_LIST,
            emergencyList: response.data.data || []
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_NOTIFICATION_ALERTS,
            unableToFetch: true
          });
        }
      });
  };
}

export function markMessagesAsRead(chatRoomData, chatMessages) {
  return (dispatch) => {
    let currentChat = cloneDeep(chatMessages[chatRoomData.id] || '');
    if (currentChat && currentChat.messages) {
      let unSeenMessageIds = [];
      each(currentChat.messages, (message) => {
        if (!message.seen) {
          message.seen = true;
          if (message.id) {
            unSeenMessageIds.push(message.id);
          }
        }
      });
      if (unSeenMessageIds.length > 0) {
        window.socket.emit('message-seen', unSeenMessageIds);
        dispatch({
          type: types.MARK_MESSAGES_AS_READ,
          chatRoomData: chatRoomData,
          currentChat: currentChat,
          unSeenMessageIds: unSeenMessageIds
        });
      }
    }
  };
}
export function markMessagesAsReadFromDropDown(jobChatRoomId) {
  window.socket.emit('message-seen', jobChatRoomId);
  return (dispatch) => {
    dispatch({
      type: types.MARK_MESSAGES_AS_READ_FROM_DROPDOWN,
      jobChatRoomId: jobChatRoomId
    })
  }
}
export function getStatistics(statisticsType) {
  return (dispatch) => {
    axios.get(statisticsType == 'daily' ? API_END_POINTS.DAILY_STATISTICS : API_END_POINTS.WEEKLY_STATISTICS)
      .then((response) => {
        if (response.status == 200 && response.data && response.data.messageAlerts) {
          dispatch({
            type: types.GET_STATISTICS,
            statisticsData: response.data.messageAlerts.messages,
            unableToFetch: false,
            statisticsType: statisticsType
          });
        } else {
          dispatch({
            type: types.GET_STATISTICS,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_STATISTICS,
            unableToFetch: true
          });
        }
      });
  };
}

export function getJobSchedule() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_JOB_SCHEDULE)
      .then((response) => {
        if (response.data) {
          dispatch({
            type: types.GET_JOB_SCHEDULE,
            jobSchedule: response.data,
            unableToFetch: false
          });
        } else {
          dispatch({
            type: types.GET_JOB_SCHEDULE,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_JOB_SCHEDULE,
            unableToFetch: true
          });
          if (err.response) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function updateJobOverview(incomingJob, jobType) {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_OVERVIEW_WINLOSS,
      incomingJob: incomingJob,
      jobType: jobType
    });
  };
}

export function toggleMessageTab(show) {
  return (dispatch) => {
    dispatch({
      type: types.TOGGLE_MESSAGE_TAB,
      show: show
    });
  };
}

export function applyPromotionalOffers(promotionData) {
  console.log('🔥 🔥 promotionData : ',promotionData);
  return (dispatch) => {
    axios.post(API_END_POINTS.APPLY_PROMOTIONAL_OFFERS, {
      'promo_code': promotionData.promo_code,
      'services': promotionData.services,
      'quote_amount': promotionData.quote_amount,
      'garage_id': promotionData.garage_id
    })
      .then((response) => {
        console.log('🔥 🔥 PROMO response.data.data : ',response.data.data);
        dispatch({
          type: types.APPLY_PROMOTIONAL_OFFERS,
          promotionalOffersMessage: response.data.data.msg,
          discountAmount: response.data.data.discount_amount,
          promotionalOffersIsApproved: true
        });
      }).catch((err) => {
      if (err) {
        dispatch({
          type: types.APPLY_PROMOTIONAL_OFFERS,
          promotionalOffersIsApproved: false,
          promotionalOffersMessage: err.response.data.err
        });
      }
    });
  };
}

export function editCarProfile(carData, isEditProfile, profileId, batchId, imageIds) {
  return (dispatch) => {
    dispatch({
      type: types.HIDE_ERROR_MESSAGE
    });
    const formData = new FormData();
    let mandateFields = ['name', 'make', 'model', 'year', 'plate_no', 'mileage', 'state', 'insurancepolicynumber', 'insuranceprovider', 'carnotes', 'registrationnumber', 'chassis_number'];

    Object.keys(carData).map((value) => {
      if (carData[value] && mandateFields.indexOf(value) !== -1) {
        if (value)
          formData.append(value, carData[value]);
      }
    });

    let requestData = {
      "batch_id": batchId,
      "chassis_number": carData.chassis_number,
      "name": carData.name,
      "make": carData.make,
      "model": carData.model,
      "year": carData.year.toString(),
      "model_id": isEditProfile ? carData.modelId : carData.model_id,
      "plate_no": carData.plate_no,
      "mileage": carData.mileage,
      "images": imageIds && imageIds.length ? imageIds : [],
      "state": carData.state,
      "insurancepolicynumber": carData.insurancepolicynumber,
      "insuranceprovider": carData.insuranceprovider,
      "registrationnumber": carData.registrationnumber,
      "carnotes": carData.carnotes
    };
    console.log('requestData ', requestData);
    // formData.append('batch_id', batchId);
    // formData.append('images', imageIds);
    const postMethod = (isEditProfile && profileId) ? axios.put : axios.post;
    // API_END_POINTS.CREATE_CAR_PROFILE + '?imageflow=1'
    postMethod(isEditProfile && profileId ? (API_END_POINTS.EDIT_CAR_PROFILES + profileId + '?imageflow=1') : API_END_POINTS.CREATE_CAR_PROFILE + '?imageflow=1', requestData, {
      withCredentials: true
    })
      .then((response) => {
        if (response.status === 200) {
          const redirect_to = (!isEditProfile && queryStringtoArray('redirect_to')) ? queryStringtoArray('redirect_to') : '';
          const vendor_id = (!isEditProfile && queryStringtoArray('vendor_id')) ? queryStringtoArray('vendor_id') : '';
          dispatch({
            type: types.SET_CAR_PROFILE,
            carData: response.data,
            redirect_to: redirect_to,
            profileId: profileId
          });
          if((!isEditProfile || !profileId) && imageIds && imageIds.length && response.data){
            dispatch(setVehicleCoverImage(imageIds[0], response.data.id));
          }
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: (isEditProfile && profileId) ? 'Car Profile has been updated successfully' : 'Car Profile has been created successfully',
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data ? response.data.msg : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      }).catch((err) => {
        // dispatch({
        //   type: types.SHOW_TOAST_MESSAGE,
        //   toastMessage: err.response.data ? err.response.data : 'Unknown error. Please try later',
        //   toastType: 'error'
        // });
        if (err.response && err.response.status === 500) {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : `Car plate ${carData.plate_no} already exist in the system please contact customer support.`
          });
        } else if (err.response && err.response.status && (err.response.status === 400 || err.response.status === 404 || err.response.status === 401 || err.response.status === 410)) {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Unknown error occurred please try again'
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      });
  };
}

export function getCarProfileDetails(carProfileID) {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_CAR_PROFILE_DETAILS + carProfileID + '?imageflow=1', { withCredentials: true })
      .then((response) => {
        console.log('GET Car Profile Details 😱 😱 😱', response.data);
        if (response.status == 200) {
          dispatch({
            type: types.VIEW_CAR_PROFILE,
            carProfile: response.data
          });
          dispatch(getCarServiceHistory(carProfileID, 10, 0, false));
        } else {
          dispatch({
            type: types.VIEW_CAR_PROFILE,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.status && err.response.status == 404) {
          //router.push(`${appBasePath}/404`);
          // dispatch({
          //   type: types.VIEW_CAR_PROFILE,
          //   unableToFetch: true
          // })
        } else {
          dispatch({
            type: types.VIEW_CAR_PROFILE,
            unableToFetch: true
          });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/commonActions.js